export default __webpack_public_path__ + "static/media/import-one.594f9fda.png";